import { Dialog } from "@headlessui/react";
import { useNavigate } from "react-router-dom";
import DialogBackdrop from "components/ModalDialogs/DialogBackdrop";
import { useTranslation } from "react-i18next";

const ConfirmModal = ({
  modalState,
  setModalState,
  unauthUser = false,
  txRefNum,
}) => {
  const navigate = useNavigate();

  const navigateTo = () => {
    setModalState(false);
    unauthUser ? navigate("/") : navigate("/policies");
  };
  const { t } = useTranslation();
  return (
    <>
      <Dialog open={modalState} onClose={navigateTo} className="ui-dialogs">
        <DialogBackdrop />
        <div className="fixed inset-0 flex items-center justify-center p-4">
          <Dialog.Panel
            role="dialog"
            aria-modal="true"
            className="ui-default-dialog ui-dialog-sm"
          >
            <Dialog.Title className="font-body text-xl font-bold text-left">
              {t("AgentAuthorizePayment-ConfirmModal-Title")}
            </Dialog.Title>
            <hr />
            <article className="mx-auto lg:w-4/5">
              <p>{t("AgentAuthorizePayment-ConfirmModal-Desc")}</p>

              <p>
                {t("AgentAuthorizePayment-ConfirmModal-Tracking")}
                <br />
                <span className="text-ui-blue text-lg font-medium">
                  {txRefNum}
                </span>
              </p>

              <p>{t("AgentAuthorizePayment-ConfirmModal-EmailNotifyDesc")}</p>
            </article>

            <div className="block text-right mt-6">
              <button
                className="ui-btn-primary min-w-[140px]  mt-4"
                aria-label="Go to my policies now"
                onClick={navigateTo}
              >
                {unauthUser ? "Close" : "Go to my policies"}
              </button>
            </div>
          </Dialog.Panel>
        </div>
      </Dialog>
    </>
  );
};

export default ConfirmModal;
